import { render } from "./ShipButton.vue?vue&type=template&id=4cfce5ef&scoped=true&ts=true"
import script from "./ShipButton.vue?vue&type=script&lang=ts"
export * from "./ShipButton.vue?vue&type=script&lang=ts"

import "./ShipButton.vue?vue&type=style&index=0&id=4cfce5ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfce5ef"]])

export default __exports__